import React, { useState, useEffect, Fragment } from "react";
import {
    StyleSheet, View, Text
} from "react-native";
import {v4 as uuidv4} from 'uuid';

import { FONT } from "../../../value/staticValues";
import { ERROR_CODE } from "../../../value/type";
import { PLATFORM_URL } from "../../../value/Url";
import { base64Encoding, getCurrentTimestamp, getTimestampToDate, parseLocaleDatetime } from "../../../common/util";
import { requests } from "../../../common/RestAPI";
import { ValidationError } from "../../../common/ExceptionError";

import StepLine from "../../base/tamplate/StepLine";

import { CustomTextInput, TextArea } from "../../base/CustomInputText";
import CustomRadioBtn from "../../base/CustomRadioBtn";
import RadioListTable from "../../base/table/RadioListTable";
import { CustomDropDown, DropdownType } from "../../base/CustomDropdown";
import { CustomCircleCheckBox, CustomSquareCheckBox } from "../../base/CustomCheckBox";


import { ReactComponent as MsgInfoImg } from '../../../img/ico-msg-info-2.svg';
import { ReactComponent as CheckRequestImg } from '../../../img/btn-radio-incon-check-inactive.svg';
import { ReactComponent as CheckImg } from '../../../img/btn-radio-incon-check-active.svg';

import { useTranslation } from "react-i18next";
import { AccountUuidParse } from "../../../interfaceTypes/AccountType";
import { InstanceTypeData } from "./InstanceTypeData";

interface InstanceTypeUpdateProps {
    showMessageCb?: Function,
    showLoadingCb?: Function,
    stepIndex: number,
    clickedConfirmYn: boolean,
    resultCb?: Function,
    stepCount: number,
    args?: InstanceTypeData,
}

InstanceTypeUpdate.defaultProps = {
    stepIndex: 0,
    clickedConfirmYn: false,
    stepCount: 1,
}

export default function InstanceTypeUpdate(props:InstanceTypeUpdateProps) {
    const { t } = useTranslation();
    const [stepIndex, setStepIndex] = useState(0);
    const [executeUpdateInstanceYn, setExecuteUpdateInstanceTypekYn] = useState(false);

    
    const [vmTypeName, setVmTypeName] = useState("");
    const [vmTypePubType, setVmTypePubType] = useState("");
    const [vmTypeCpu, setVmTypeCpu] = useState("");
    const [vmTypeMem, setVmTypeMem] = useState("");
    const [vmTypeRootDisk, setVmTypeRootDisk] = useState("");
    const [vmTypeTempDisk, setVmTypeTempDisk] = useState("");
    const [vmTypeSwapDisk, setVmTypeSwapDisk] = useState("");
    const [hostCluster, setHostCluster] = useState("");
    const [createDate, setCreateDate] = useState("");
    const [updateDate, setUpdateDate] = useState("");
    const [projectName, setProjectName] = useState("");
    const [gpuYn, setGpuYn] = useState(false);
    


    useEffect(() => {
        if(props.showMessageCb) {
            props.showMessageCb("");
        }
        setStepIndex(props.stepIndex);
    }, [props.stepIndex]);

    useEffect(() => {
        if(props.clickedConfirmYn === true) {
            executeUpdateVmType();
        }
    }, [props.clickedConfirmYn]);

    useEffect(() => {
        if(props.args) {
            parseInstanceType(props.args);
        }
    }, [props.args]);

    function parseInstanceType(data) {
        setVmTypeName(data.vm_type_name);
        setVmTypePubType(data.share_type_code);
        setVmTypeCpu(data.vcpu_count.toString());
        setVmTypeMem(data.memory_capacity_mb.toString());
        setVmTypeRootDisk(data.root_disk_capacity_gb.toString());
        setVmTypeTempDisk(data.ephemeral_disk_capacity_gb.toString());
        setVmTypeSwapDisk(data.swap_disk_capacity_mb.toString());
        setGpuYn(data.gpu_available_yn);
        setHostCluster(data.host_cluster_type_code);
        setCreateDate(parseLocaleDatetime(data.create_ts));
        setUpdateDate(parseLocaleDatetime(data.update_ts));
        setProjectName(data.project ? data.project.project_name : '');
    }

    function executeResult(result, closeYn, infoMessage) {
        if(props.showMessageCb && infoMessage) {
            props.showMessageCb(infoMessage);
        }
        if(props.resultCb) {
            props.resultCb(result, closeYn);
        }
    }



    function executeUpdateVmType() {
        const body = {
            vm_type:{
                share_type_code: vmTypePubType
            }
        };
        requests.put(PLATFORM_URL.INSTANCE_TYPE + '/' + props.args?.vm_type_id, body)   
        .then((response) => {
            if(response.status === 200) {
                executeResult({successYn: true }, true, "");
            } else {
                executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
            }

        })
        .catch((error) => {
            executeResult({successYn: false}, false, t("MESSAGE_CANNOT_COMMIT_DATA_MESSAGE"));
        });
    }

    function selectButton(id, type){
        setVmTypePubType(type);
    }
    return (
        <View>
            {
                stepIndex === 0 ?
                <View>
                    <View style={style.infoBoxContainer}>
                        <MsgInfoImg/>
                        <Text style={style.infoBoxContainerText}>
                            {t("VM_TYPE_UPDATE_INFO_MESSAGE")}
                        </Text>
                    </View>
                    <Text style={style.titleText}>{
                        t("BASE_INFO_TEXT")}
                    </Text>
                    <View style={style.mainContainer}>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_TYPE_NAME_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={2} 
                                width={570} height={36} 
                                value={vmTypeName} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={setVmTypeName} 
                                warnYn={false} 
                                placeHolderText={t("NAME_ENTER_MESSAGE")}
                            />
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_CPU_TEXT")}
                            </Text>
                            <View style={{flexDirection: "row", alignItems: "center"}}>
                                <CustomTextInput 
                                    key={3} 
                                    width={110} height={36} 
                                    value={vmTypeCpu} 
                                    type={"text"} 
                                    activeYn={false} 
                                    inputCb={setVmTypeMem} 
                                    warnYn={false}
                                />
                                <Text style={style.diskUsageText}>
                                    cores
                                </Text>
                            </View>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_MEMORY_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={3} 
                                width={110} height={36} 
                                value={vmTypeMem} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={setVmTypeMem} 
                                warnYn={false}
                            />
                            <Text style={style.diskUsageText}>
                                MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_ROOT_DISK_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={110} height={36} 
                                value={vmTypeRootDisk} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={setVmTypeRootDisk} 
                                warnYn={false} 
                            />
                            <Text style={style.diskUsageText}>
                                GB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_TEMP_DISK_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={110} height={36} 
                                value={vmTypeTempDisk} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={setVmTypeTempDisk} 
                                warnYn={false} 
                            />
                            <Text style={style.diskUsageText}>
                                MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_SWAP_DISK_TEXT")}
                            </Text>
                            <CustomTextInput 
                                key={4} 
                                width={110} height={36} 
                                value={vmTypeSwapDisk} 
                                type={"text"} 
                                activeYn={false} 
                                inputCb={setVmTypeSwapDisk} 
                                warnYn={false} 
                            />
                            <Text style={style.diskUsageText}>
                                MB
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_GPU_TEXT")}
                            </Text>
                            <CustomSquareCheckBox 
                                id={"GpuYn"}
                                key={33} 
                                checked={gpuYn}
                                disabled={true}
                                label={t("USE_TEXT")}
                                setCheckBoxStatus={(e) => {}}
                            />
                        </View>
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("SHARE_CATEGORY_TEXT")}
                            </Text>
                            <CustomRadioBtn
                                id={"ImageShareType"}
                                type={"PUB"}
                                size={18}
                                activeYn={true}
                                checked={vmTypePubType === "PUB" ? true: false}
                                selectCb={selectButton}
                                label={"공용(Pubilc)"}
                                labelStyle={labelStyle}
                            />
                            <View style={{width: 44}}/>
                            {
                                props.args?.share_type_code === "PRJ"
                                ? <CustomRadioBtn
                                id={"InstanceShareType"}
                                    type={"PRJ"}
                                    size={18}
                                    activeYn={true}
                                    checked={vmTypePubType === "PRJ" ? true: false}
                                    selectCb={selectButton}
                                    label={"개인(프로젝트)"}
                                    labelStyle={labelStyle}
                                />
                                : null
                            }
                            <View style={{width: 44}}/>
                            {
                                props.args?.share_type_code === "HDN"
                                ?
                                <CustomRadioBtn
                                    id={"InstanceShareType"}
                                    type={"HDN"}
                                    size={18}
                                    activeYn={false}
                                    checked={vmTypePubType === "HDN" ? true: false}
                                    selectCb={selectButton}
                                    label={"숨김(사용불가)"}
                                    labelStyle={labelStyle}
                                />
                                : null
                            }
                        </View>
                        {
                            props.args?.share_type_code === "PRJ" ?
                            <View style={style.rowContainer}>
                                <Text style={style.columnText}>
                                    {t("PROJECT_INFO_TEXT")}
                                </Text>
                                <CustomTextInput
                                    key={112}
                                    width={300} height={36}
                                    value={projectName}
                                    type={"text"}
                                    activeYn={false}
                                    inputCb={(e) => {}}
                                    warnYn={false}
                                />
                            </View>
                            : null
                        }
                        {
                            props.args?.share_type_code !== "PUB"
                            ?<Text style={{...style.rowDescribeContainer, marginBottom: 20}}>
                                {t("MESSAGE_INSTANCE_TYPE_SHARED_TYPE_CHANGE_DESCRIBE_MESSAGE")}
                            </Text>
                            : null
                        }
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("INSTANCE_TARGET_HOST_CLUSTER_TEXT")}
                            </Text>
                            <div style={{paddingLeft: 10, paddingRight: 10,
                                    display: "flex", alignItems: "center", justifyContent: "center",
                                    borderRadius: 10,
                                    backgroundColor: "#b6bfce",
                                    fontFamily: FONT.REGULAR,
                                    fontSize: 12,
                                    color: "#fff"}}>
                                {
                                    hostCluster === "CMP" ? t("COMPUTE_TYPE_TEXT")
                                    : hostCluster === "MEM" ? t("MEMORY_TYPE_TEXT")
                                    : hostCluster === "GPU" ? t("GPU_TYPE_TEXT")
                                    : hostCluster === "STRG" ? t("STORAGE_TYPE_TEXT")
                                    : hostCluster === "NET" ? t("네트워크용")
                                    : t("NORMAL_TYPE_TEXT")
                                }
                            </div>
                        </View>
                        <View style={style.rowDivContainer}></View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("UPDATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateText}>
                                {updateDate}
                            </Text>
                        </View>
                        <View style={style.rowContainer}>
                            <Text style={style.columnText}>
                                {t("CREATE_DATE_TEXT")}
                            </Text>
                            <Text style={style.dateText}>
                                {createDate}
                            </Text>
                        </View>
                    </View>
                </View>
                :null 
            }
        </View>
    )
}


const style = StyleSheet.create({
    titleText: {
        marginTop: 40,
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        fontWeight: "500",
        color: "#0853fb",
    },
    mainContainer: {
        marginTop: 38
    },
    rowContainer: {
        height: 36,
        flexDirection: "row",
        marginBottom: 30,
        alignItems: "center"
    },
    rowTopAlignContainer: {
        minHeight: 36,
        flexDirection: "row",
        marginBottom: 30,
    },
    rowDivContainer: {
        borderStyle: "solid",
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
        marginBottom: 30,
    },
    rowDescribeContainer: {
        marginLeft: 150, marginTop: -10, marginBottom: 40,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 12,
        color: "#8c8c8c"
    },
    columnText: {
        width: 150,
        fontFamily: FONT.REGULAR,
        fontSize: 13,
        color: "#333",
    },
    infoBoxContainer: {
        flexDirection: "row", alignItems: "center",
        width: 700, height: 40,
        paddingLeft: 10, paddingRight: 10,
        marginBottom: 15,
        borderRadius: 2,
        backgroundColor: "#fafafa"
    },
    infoBoxContainerText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        lineHeight: 18,
        color: "#9ea0a5"
    },
    diskUsageText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowInfoText: {
        marginLeft: 10,
        fontFamily: FONT.REGULAR,
        fontSize: 11,
        lineHeight: 10,
        color: "#9ea0a5"
    },
    rowStaticText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333"
    },
    dateText: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#9ea0a5"
    }
});

const labelStyle = {
    fontFamily: FONT.REGULAR,
    fontSize: 12,
    color: "#333"
}